export default __webpack_public_path__ + "static/impact-photo-sophie-15be875f34b0a66a4e40ced9c1db08ff.jpg";